import React from 'react';
import { Rect } from 'react-konva';
import { DragRectangleProps } from './constants';

type Props = {
  dragOverlayRect: DragRectangleProps;
  layerOverlayRect: DragRectangleProps;
};
export const CanvasDragAndDrop = ({ dragOverlayRect, layerOverlayRect }: Props) => {
  return (
    <>
      <Rect
        data-testid="drag-rect"
        x={dragOverlayRect.x}
        y={dragOverlayRect.y}
        width={dragOverlayRect.width}
        height={dragOverlayRect.height}
        fill="transparent"
        opacity={1}
        visible={dragOverlayRect.visible}
        listening={false}
        stroke={'orange'}
        strokeWidth={3}
      />
      <Rect
        data-testid="layer-rect"
        x={layerOverlayRect.x}
        y={layerOverlayRect.y}
        width={layerOverlayRect.width}
        height={layerOverlayRect.height}
        fill="rgba(200,200,200, 0.6)"
        opacity={0.8}
        visible={layerOverlayRect.visible && dragOverlayRect.visible}
        listening={false}
        stroke={'orange'}
        strokeWidth={3}
      />
    </>
  );
};

export const ScreenToCustomlayerWarning = () => {
  return (
    <div>
      You are copying the screen as a condition list. As such, ROCK MAKER will treat each
      well in the condition list layer individually and not as a screen layer.
      <br />
      Do you want to continue?
    </div>
  );
};
